export default "/_next/static/images/Wire-1-8adcbce62f300b6a9303cc8cff69845c.svg";